"use client";

import { Dialog } from "primereact/dialog";
import { ReactNode } from "react";

interface DialogInterface {
    children: ReactNode;
    open: boolean;
    header?: any;
    footer?: any;
    position?: any; // "left" | "right" | "top-left" | "top-right" | "bottom" | "bottom-left" | "bottom-right"
    size?: "xs" | "sm" | "md" | "lg";
    maximizable?: boolean;
    onShow?: any;
    onHide?: any;
}

export default function AppDialog(props: DialogInterface) {
    const { children, footer, header, maximizable, open, position, size="sm", onShow, onHide } = props;

    const sizes = {
        xs: 20,
        sm: 30,
        md: 50,
        lg: 70
    }

    const handleHide = () => {
        onHide();
    }

    return (
        <Dialog
            header={header}
            footer={footer}
            visible={open}
            position={position}
            maximizable={maximizable ?? false}
            style={{width: `${sizes[size]}vw`}}
            // className="px-3"
            breakpoints={{
                "1480px": sizes[size]+5+"vw",
                "1287px": sizes[size]+20+"vw",
                "992px": 50+sizes[size]+"vw",
                "639px": "95vw",
            }}
            onShow={onShow}
            onHide={handleHide}
        >
            { children }
        </Dialog>
    )
}